<template>
    <div class="px-0">
         <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('pickup_addresses.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" :to="'/pickup_addresses/create'" v-permission="'client.create'">
                        {{ $t('pickup_addresses.new_customer') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>  
        </v-container>  

        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { indexPickupAddressesUseCase } from '../../application/use_cases/index_pickup_addresses_use_case';
import { HttpPickupAddressRepository } from '../../infrastructure/pickup_address_repository';

export default {
    computed: {
        headers(){
            var headers = [
                { text: this.$t('pickup_addresses.address'), align: "center", value: 'address.direction', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.state'), align: "center", value: 'address.state', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.city'), align: "center", value: 'address.municipality', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.neighborhood'), align: "center", value: 'address.neighborhood', class: 'text-uppercase' },
                { text: this.$t('pickup_addresses.zipcode'), align: "center", value: 'address.zipcode', class: 'text-uppercase' },
            ];

            if(this.$store.state.clients.length > 1) headers.splice(0, 0, { text: this.$t('pickup_addresses.customer'), align: "center", value: 'client_name', class: 'text-uppercase', sortable: false },)

            return headers;
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: []
            },
        }
    },
    mounted(){
        this.$store.state.module = "headers.pickup_addresses";
        this.loadData();
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async loadData(){
            try {
                const response = await indexPickupAddressesUseCase(this.$store.state.clients.map(x => x.id).join(','), HttpPickupAddressRepository);
                this.props.items = response;
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
    },
    watch:{
    }
}
</script>

<style>

</style>